let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    console.log(eventName);
    if(eventName == 'cart-update'){
          const event22 = new CustomEvent('cart-update', { detail: eventName });
          document.dispatchEvent(event22);
     // console.log(eventName);
    }
 
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
